const quantityField = document.querySelector("#customQuantity");

const volumeDiscountsComponent = document.querySelector('#volume-discounts-component');
const volumeDiscountsContentWrapper = document.querySelector('#volume-discounts-content-wrapper');
const allDiscounts = document.querySelectorAll('.productVariant');
const addEventListeners = () => {
    document.querySelectorAll(".productVariant").forEach((el) => {
        el.addEventListener("click", function () {
            getActive().classList.remove("active");
            this.classList.add("active");
            const quantity = this.getAttribute("data-quantity");
            const price = this.getAttribute("data-price");
            const compareAtPrice = this.getAttribute("data-compare-at-price");
            const discountPercentage = this.getAttribute("data-discount-percentage");
            const dataCurrency = this.getAttribute("data-currency");
            updateQuantityField(quantity)
            dispatchVolumeDiscountEvent(false);
            updateTotalPrice(price, compareAtPrice, discountPercentage, dataCurrency,quantity)
        });
    });
};
const updateQuantityField = (quantity => {
    quantityField.setAttribute("value", +quantity);
})
const getActive = () => {
    return document.querySelector('.productVariant.active');
}
const dispatchVolumeDiscountEvent = (initialLoad) => {
    const active = +getActive().getAttribute('data-quantity')
    const event = new CustomEvent('custom:volume-discount-change', {
        detail: {
            active,
            maxGifts: allDiscounts.length,
            initialLoad: initialLoad
        }
    })
    document.documentElement.dispatchEvent(event);
}

const updateTotalPrice = (price, compareAtPrice, discountPercentage, dataCurrency,quantity) => {
    price = parseFloat(`${price}`.replace('.','').replaceAll(',','.'));

    if(!compareAtPrice){
        compareAtPrice = price
    }else{
        compareAtPrice=parseFloat(`${compareAtPrice}`.replace('.','').replaceAll(',','.'));
    }

    discountPercentage = parseFloat(`${discountPercentage}`);


    const totalPrice = document.querySelector('#totalPrice');

    const percentagedPrice = (discountPercentage / 100) * compareAtPrice;

   const finalPrice =discountPercentage> 0? parseFloat(compareAtPrice - percentagedPrice).toFixed(2):price;

   if(discountPercentage == 0){
       discountPercentage = Math.round(((compareAtPrice-price)*100)/compareAtPrice);
   }
   if(discountPercentage){
       totalPrice.innerHTML = `<p style="font-family: 'DIN Next' !important;">Precio total: ${parseFloat(finalPrice*quantity).toFixed(2)}${dataCurrency} <span style="text-decoration: line-through;color: rgba(51, 51, 51, 0.5)">${Math.fround(compareAtPrice*quantity).toFixed(2)}${dataCurrency}</span> (-${discountPercentage.toFixed(2)}%)</p>`;
   }else{
       totalPrice.innerHTML = `<p style="font-family: 'DIN Next' !important;">Precio total: ${finalPrice*quantity}${dataCurrency}</p>`;

   }
}
window.addEventListener('load', () => {
    addEventListeners();
    updateQuantityField(getActive().getAttribute('data-quantity'));
    volumeDiscountsContentWrapper.appendChild(volumeDiscountsComponent);
    volumeDiscountsComponent.classList.add('activated');
    dispatchVolumeDiscountEvent(true);

    const quantity = getActive().getAttribute("data-quantity");
    const price = getActive().getAttribute("data-price");
    const compareAtPrice = getActive().getAttribute("data-compare-at-price");
    const discountPercentage = getActive().getAttribute("data-discount-percentage");
    const dataCurrency = getActive().getAttribute("data-currency");

    updateTotalPrice(price, compareAtPrice, discountPercentage, dataCurrency,quantity)
});